import { Component, HostListener, Input, SecurityContext, SimpleChanges } from '@angular/core';
import { ConnectionService } from 'src/app/shared/services/connection/connection.service';
import { LookupConstant } from 'src/app/shared/entity/lookup-constant';
import { DateFormatPipe } from 'src/app/shared/pipe/date-format-pipe/date-format.pipe';
import { ColorIndicationStatus } from 'src/app/shared/entity/enums'
import { DomSanitizer } from '@angular/platform-browser';
import { Column } from 'src/app/modules/gantt/component/gantt/gantt.component';
import { AppConstants } from '../../entity/constants';
import JsBarcode from 'jsbarcode';
interface ItemDetail {
  receivername: string,
  pn_item_id: string,
  product_code: string,
  itemState: string,
  eventcode: string,
  reasoncode: string,
  photo_delivery_flow: string
  task_sequence: number,
  eta: string,
  ata: string,
  task_time_window: string,
  status: string
  is_same_day_shipment?: boolean;
}

@Component({
    selector: 'app-route-item-details',
    templateUrl: './route-item-details.component.html',
    styleUrls: ['./route-item-details.component.scss', '../../../shared/css/primeng-table.component.scss'],
    standalone: false
})
export class RouteItemDetailsComponent {
  @Input() routeDetails: any;
  @Input() itemColumnNames: Column[];
  @Input() taskid?: string;
  @Input() paginator: boolean;
  @Input() showBarcode: boolean;
  itemDetails: ItemDetail[] = [];
  HCPEventCodes: any = LookupConstant.HCPEventCodes;
  HCPReasonCodes: any = LookupConstant.HCPReasonCodes;
  @Input() itemState: string;
  wrapUnwrap = false;
  status: any = ColorIndicationStatus
  showPhotoDeliveryFlow = false;
  photoDeliveryFlow: any;
  first:number = 0;
  rows:number = 10;

  @HostListener('window:keydown.control.p', ['$event'])
  handlePrint(event: KeyboardEvent) {
    event.preventDefault();
    this.printTable()
  }
  constructor(private connectionService: ConnectionService, private dateFormatPipe: DateFormatPipe,
    private readonly sanitizer: DomSanitizer
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.routeDetails) {
      this.getItemDetails();
    }
    if (this.taskid && !this.routeDetails) {
      this.getItems();
      this.first = 0;
      this.rows = 10;
    }
  }

  /**
   * based on taskid calling itemdetails api
   * @returns selected item information
   */
  getItems() {
    if (!this.taskid) {
      return;
    }
    let queryParams: any = {};
    if (this.taskid) {
      queryParams.taskid = this.taskid ?? ''
    }
    this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `itemsDetails`,
      directoryType: AppConstants.DP,
      data: queryParams,
      isLoader: true
    }).subscribe({
      next: (response: any) => {
        if (response) {
          this.itemDetails = response.items.map((item: any) => ({
            barcode: item.barcode[0],
            receivername: item.consignee_name,
            pn_item_id: item.pn_item_id,
            product_code: item.product_code ? item.product_code : '',
            itemState: item.item_state,
            is_same_day_shipment: item.is_same_day_shipment??false,
          }));
        }
      },
      error: (error: any) => {
      },
    });
  }

  getItemDetails() {
    this.itemDetails = []
    if (!this.routeDetails?.route_id) {
      return;
    }
    let queryParams: any = {
      itemState: this.itemState,
    }
    if (this.itemState === 'FailedAttempt' && this.taskid) {
      queryParams.taskid = this.taskid ?? ''
    }
    this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `${this.routeDetails.route_id}/itemsDetails`,
      directoryType: AppConstants.DP,
      data: queryParams,
      isLoader: true
    }).subscribe({
      next: (response: any) => {
        if (response) {
          this.itemDetails = response.items.map((item: any) => ({
            receivername: item.consignee_name,
            pn_item_id: item.pn_item_id,
            product_code: item.product_code ? item.product_code : '',
            itemState: item.item_state,
            address: item.consignee_address,
            gttEvent: item.events[0]?.fors_haend_type ? `${item.events[0]?.fors_haend_type}` : '',
            eventcode: item.events[0]?.event_code ? `${LookupConstant.HCPEventCodes[item.events[0]?.event_code] ?? ''} (${item.events[0]?.event_code})` : '',
            reasoncode: item.events[0]?.reason_code ? `${this.getHCPReasonCode(item.events[0]?.reason_code)} (${item.events[0]?.reason_code})` : '',
            task_sequence: item.task_sequence + 1,
            eta: this.dateFormatPipe.transform(item.task_eta, 'time'),
            ata: this.dateFormatPipe.transform(item.task_ata, 'time'),
            task_time_window: `${this.dateFormatPipe.transform(item.task_time_window.begin, 'time')} - ${this.dateFormatPipe.transform(item.task_time_window.end, 'time')}`,
            status: item.status,
            photo_delivery_flow: item?.events[0]?.photo_delivery_flow ? item?.events[0]?.photo_delivery_flow : '',
          }));
        }
      },
      error: (error: any) => {
      },
    });
  }


  getHCPEventCode(eventcode: string) {
    if (eventcode) {
      const defination = this.HCPEventCodes[eventcode]
      return defination ?? ''
    }
    return ''
  }

  getHCPReasonCode(reason_code: string) {
    if (reason_code) {
      const defination = this.HCPReasonCodes[reason_code]
      return defination ?? ''
    }
    return ''
  }

  barcodeClicked(row: any) {
    window.open('#/lookup?barcode=' + row?.pn_item_id, "_blank");
  }

  /**
   * To open popup to show the Photo Delivery Flow Image
   * @param diaImage To accept base64 string
   */
  openDIAImage(diaImage: string) {
    this.photoDeliveryFlow = "data:image/PNG;base64 ," + diaImage;
    this.showPhotoDeliveryFlow = true;
  }

  printTable() {
    // Create a temporary container for the printable table
    const printContainer = document.createElement('div');

    // Build the HTML for the table and generate barcodes simultaneously
    let tableHTML = `
      <table style="width: 100%; border-collapse: collapse; text-align: left;">
        <thead>
          <tr>
          <th >Receiver Name</th>
          <th >Barcode</th>
          <th >Item State</th>
          <th >Product Code</th>
          </tr>
        </thead>
      <tbody>
    `;
    const barcodeValues: string[] = [];
    const itemDetails = [...this.itemDetails];
    itemDetails.splice(this.first, this.rows).forEach((row, index) => {
      barcodeValues.push(row.pn_item_id ?? '');

      // Append the table row with the barcode HTML
      tableHTML += `
        <tr>
        <td >${row.receivername??''}</td>
        <td ></td>
        <td >${row.itemState}</td>
        <td >${row.product_code}</td>
        </tr>
      `;
    });

    tableHTML += '</tbody></table>';
    printContainer.innerHTML = this.sanitizer.sanitize(SecurityContext.HTML, tableHTML) ?? '';

    // Open the print window
    const printWindow: any = window.open('_blank', 'width=800,height=600');
    printWindow.document.open();
    printWindow.document.write(`
    <html>
    <head>
      <title>Parked Items</title>
    <style>
              table { width: 100%; border-collapse: collapse; text-align: left; }
              th, td { border: 1px solid black; padding: 8px; }
              svg { max-width: 100%; height: auto; }
    </style>
    </head>
      <body>${printContainer.innerHTML}</body>
    </html>
    `);
    printWindow.document.close();
    const barcodeCells = printWindow.document.querySelectorAll('tbody tr td:nth-child(2)');
    barcodeValues.forEach((barcodeValue, index) => {
      const barcodeCell = barcodeCells[index];
      if (barcodeCell) {
        const barcodeSvg = printWindow.document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        JsBarcode(barcodeSvg, barcodeValue, {
          width: 2,
          height: 50,
        });
        barcodeCell.appendChild(barcodeSvg);
      }
    });
    printWindow.print();
  }

  /**
   * 
   * @param $event 
   */
  onPageChange($event: any) {
    this.first = $event.first;
    this.rows = $event.rows;
  }

}
